import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

interface ChipProps {
	label: string;
	active?: boolean;
	color?: boolean;
}

export const TabChip: FunctionComponent<ChipProps> = ({ label, active, color }) => {
	return (
		<div
			className={classNames(
				"ml-1 opacity-[0.8] leading-[14px] font-medium text-xs px-1.5 py-1 rounded-[10px]",
				active
					? `${color ? "bg-status-warning text-white" : "bg-brand-light text-white"}`
					: "bg-gray-200 text-gray-700"
			)}
		>
			{label}
		</div>
	);
};
